<template>
  <form
    class="sm-form sm-form__new-mail"
    @submit.prevent="handleSubmit"
  >
    <h3>{{title}}</h3>
    <div class="sm-form__new-mail-flex">
      <input-pmb-tags
        :label="'Mailbox number'"
        :placeholder="'Name, Mailbox# or Company name'"
        :defaultTag="startPMB"
        :accountNum="formData.account_numbers[0]"
        :error="errors.first('account_numbers')"
        :maxTags="1"
        :disabled="type === 'edit' ? true : false"
        @updateList="updatePMBList($event)"
      />
      <input-text
        v-model="formData.sender"
        v-validate="'required'"
        data-vv-as="Sender"
        :label="'Sender'"
        :name="'sender'"
        :disabled="type === 'edit' ? true : false"
        :error="errors.first('sender')"
      />
    </div>
    <div class="sm-form__new-mail-flex">
      <dropdown-wrap
        v-model="selectedType"
        :val="mailTypes[0]"
        :options="mailTypes"
        :capitalize="true"
        :placeholder="'Select mail type...'"
        :label="'Mail Type'"
        :class="'mail-type'"
        @input="changeMailType"
      />
      <checkbox-block
        v-model="formData.is_scannable"
        :text="'Scannable'"
      />
    </div>
    <div class="sm-form__new-mail-flex">
      <div class="sm-form__new-mail-flex-weight">
        <dropdown-wrap
          v-model="selectedWeightUnit"
          :val="weightUnits[0]"
          :options="weightUnits"
          :capitalize="true"
          :label="'Weight'"
          @input="formData.weight_unit = selectedWeightUnit.code"
        />
        <input-number
          v-model="formData.weight"
          :defaultVal="formData.weight || 0"
          :min="0"
          :showControls="false"
        />
      </div>
      <input-number
        v-model="formData.quantity"
        :defaultVal="formData.quantity || 1"
        :min="1"
        :label="'Quantity'"
      />
    </div>
    <input-text
      v-model="formData.tracking"
      :label="'Tracking number'"
      :name="'tracking'"
    />
    <dropdown-wrap
      v-model="selectedMessage"
      :options="messagesList"
      :placeholder="'Add message'"
      :label="'Message'"
      @input="selectMessage"
    />
    <template v-if="selectedMessage.value">
      <div
        v-if="selectedMessage.value != 'custom'"
        class="sm-form__new-mail-message"
      >{{selectedMessage.text}}</div>
      <textarea
        v-else
        v-model="formData.comments"
        class="sm-form__new-mail-textarea"
        placeholder="Message..."
      ></textarea>
    </template>
    <btn-block
      :text="'Add mail'"
      type="submit"
    />

    <sm-spinner :show="showSpinner" />
  </form>
</template>

<script>
import InputText from '@/components/InputText';
import InputNumber from '@/components/InputNumber';
import InputPMBTags from '@/components/mail/InputPMBTags';
import DropdownWrap from '@/components/DropdownWrap';
import Checkbox from '@/components/Checkboxes';
import Spinner from '@/components/Spinner';
import { mapActions, mapGetters } from 'vuex';
import WeightUnits from '@/settings/weight-units';
import MessagesList from '@/settings/messages-list';
import Mail from '@/settings/mail';

export default {
  name: 'form-new-mail',
  components: {
    'input-text': InputText,
    'input-number': InputNumber,
    'input-pmb-tags': InputPMBTags,
    'dropdown-wrap': DropdownWrap,
    'checkbox-block': Checkbox,
    'sm-spinner': Spinner
  },
  props: {
    startPMB: {},
    startVal: {
      type: Object,
      default: () => new Object()
    },
    title: {
      type: String,
      default: 'New mail'
    },
    type: {
      type: String,
      default: 'new'
    }
  },
  data() {
    return {
      formData: {
        id: null,
        received_at: this.$moment(new Date()).format('YYYY-MM-DD'),
        account_numbers: [],
        sender: '',
        quantity: 1,
        mail_type_id: '',
        is_scannable: true,
        weight: 0,
        weight_unit: 'lb',
        tracking: '',
        comments: '',
      },
      selectedMessage: {},
      selectedWeightUnit: null,
      selectedType: {},
      weightUnits: [],
      messagesList: [],
      showSpinner: false,
      accPMB: {
        classes: "active",
        company: "",
        inactive: "false",
        jt_name: null,
        mailbox_only: false,
        name: "Martin Woodard",
        pmb: 5,
        status: "Active",
        text: "Mailbox #2",
        tiClasses: ["ti-valid"],
      }
    }
  },
  created() {
    this.showSpinner = true;
    this.weightUnits = WeightUnits;
    this.messagesList = MessagesList;

    if (this.type === 'new' && Object.keys(this.startPMB).length)
      this.formData.account_numbers[0] = this.startPMB.pmb;
    else
      this.formData.account_numbers[0] = this.startVal.account_number;

    Promise.all([
      this.getMailTypes()
    ])
      .then(([mail_types]) => {
        if (Object.keys(this.startVal).length)
          Object.keys(this.formData).forEach(key => {
            if (this.startVal[key]) {
              this.formData[key] = this.startVal[key];
            }
            
          })

        if (!this.formData.mail_type_id)
          this.formData.mail_type_id = this.mailTypes[0].id;

        if (!this.formData.id)
          this.formData.id = `new-${Math.floor(Math.random()*90000) + 10000}`;

        this.showSpinner = false;
      });
  },
  computed: {
    ...mapGetters({
      mailTypes: 'mailTypes',
    })
  },
  methods: {
    ...mapActions({
      getMailTypes: 'getMailTypes'
    }),
    selectMessage() {
      if (this.selectedMessage.value != 'custom') {
        this.formData.comments = this.selectedMessage.text;
      } else {
        this.formData.comments = '';
      }
    },
    handleSubmit()  {
      this.$validator.validate()
        .then(valid => {
          if (!this.formData.account_numbers.length) {
            this.errors.add({
              field: 'account_numbers',
              msg: 'Select at least one Mailbox#'
            });
            valid = false;
          }

          if (!valid)
            return;

          let sendData = Object.assign({}, this.formData);
          sendData.account_number = this.formData.account_numbers[0];
          delete sendData.account_numbers;

          // this.formData.weight = parseInt(this.formData.weight);

         this.$emit('submit', sendData);
        });
    },
    updatePMBList(list) {
      this.formData.account_numbers = list;

      if (this.formData.account_numbers.length)
        this.errors.remove('account_numbers');
    },
    changeMailType() {
      this.formData.mail_type_id = this.selectedType.id;
      this.formData.is_scannable = Mail.defaultScannableTypes.includes(this.selectedType.name.toLowerCase());
    }
  },
  watch: {
    'startVal.comments'(val) {
      this.selectedMessage = this.messagesList.find(msg => msg.text == val) || {};
    }
  }
}
</script>